const routes = [
  {
    path: '/oldprivacy',
    name: 'oldprivacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/oldPrivacy.vue'),
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/Privacy.vue'),
  },
  {
    path: '/argement',
    name: 'Argement',
    component: () => import(/* webpackChunkName: "about" */ '../views/argement.vue'),
  },
  {
    path: '/schemeLink',
    name: 'SchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/schemeLink.vue'),
  },
  {
    path: '/bfCallback',
    name: 'BfCallback',
    component: () => import(/* webpackChunkName: "about" */ '../views/bfCallback.vue'),
  },
  {
    path: '/electronicContract',
    name: 'electronicContract',
    component: () => import(/* webpackChunkName: "about" */ '../views/electronicContract.vue'),
  },
  {
    path: '/xcxSchemeLink',
    name: 'xcxSchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/xcxSchemeLink'),
  },
  {
    path: '/wxXcxSchemeLink',
    name: 'wxXcxSchemeLink',
    component: () => import(/* webpackChunkName: "about" */ '../views/wxXcxSchemeLink'),
  },
]

export default routes
